import { render, staticRenderFns } from "./LayoutBasic.vue?vue&type=template&id=be89f022"
import script from "./LayoutBasic.vue?vue&type=script&lang=js"
export * from "./LayoutBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports